import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import ProviderModal from "./ProviderRequestsModal";
import { useTranslation } from "react-i18next";
import { getAdminMenus } from "../../contexts/AdminMenus";
import DashboardSidebarMenu from "../../components/controls/DashboardSideBarMenu";
import { fetchPendingApprovalProviders } from "../../db/Providers";

const ProviderGrid = () => {
  const { t } = useTranslation();
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const title = t("admin.title");
  const menus = getAdminMenus();

  useEffect(() => {
    const fetchProviders = async () => {
      const fetchedProviders = await fetchPendingApprovalProviders();
      setProviders(fetchedProviders);
    };

    fetchProviders();
  }, []);

  const openModal = (provider) => {
    setSelectedProvider(provider);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedProvider(null);
    setIsModalOpen(false);
  };

  const gridColumns = [
    {
      headerName: t("providerRequestsGrid.companyName"),
      field: "companyName",
      sortable: true,
      filter: true,
    },
    {
      headerName: t("providerRequestsGrid.contactPerson"),
      field: "contactPerson",
      sortable: true,
      filter: true,
    },
    {
      headerName: t("providerRequestsGrid.phoneNumber"),
      field: "phoneNumber",
      sortable: true,
      filter: true,
    },
    {
      headerName: t("providerRequestsGrid.contactEmail"),
      field: "contactEmail",
      sortable: true,
      filter: true,
    },
    {
      headerName: t("providerRequestsGrid.status"),
      field: "status",
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        let statusClass = "";
        let statusLabel = "";

        // Déterminer la classe et le label basés sur le statut
        switch (params.value) {
          case "pending":
            statusClass = "bg-yellow-500 text-black";
            statusLabel = t("status.pending");
            break;
          case "accepted":
            statusClass = "bg-green-500 text-white";
            statusLabel = t("status.accepted");
            break;
          case "refused":
            statusClass = "bg-red-500 text-white";
            statusLabel = t("status.refused");
            break;
          default:
            statusClass = "bg-gray-500 text-white";
            statusLabel = t("status.unknown");
        }

        return (
          <span
            className={`px-3 py-1 rounded-full text-sm font-medium ${statusClass}`}
          >
            {statusLabel}
          </span>
        );
      },
    },
    {
      headerName: t("providerRequestsGrid.actions"),
      field: "actions",
      cellRenderer: (params) => (
        <button
          onClick={() => openModal(params.data)}
          className="bg-primary text-white px-4 py-2 rounded-full hover:bg-accent transition h-full flex items-center justify-center"
          style={{ height: "100%" }}
        >
          {t("providerRequestsGrid.viewDetails")}
        </button>
      ),
    },
  ];

  return (
    <div className="flex">
      {/* Menu latéral à gauche */}
      <DashboardSidebarMenu title={title} menus={menus} />

      {/* Grille à droite */}
      <div className="flex-1 p-4">
        <h1 className="text-3xl font-bold mb-4 text-onWhite">
          {t("providerRequestsGrid.title")}
        </h1>
        <div
          className="ag-theme-alpine text-onWhite"
          style={{ height: "100%", width: "100%" }}
        >
          <AgGridReact
            rowData={providers}
            columnDefs={gridColumns}
            domLayout="autoHeight"
            animateRows
            rowSelection="single"
          />
        </div>
        {isModalOpen && selectedProvider && (
          <ProviderModal
            provider={selectedProvider}
            onClose={closeModal}
            showButtons={true}
          />
        )}
      </div>
    </div>
  );
};

export default ProviderGrid;
